import { Utilities } from "doshx_controls_web";
/**
 * The currency all prices in this store are denominated in.
 *
 * `Utilities.formatMoney` from doshx_controls_web defaults its symbol to "R"
 * (South African Rand) when none is supplied, so every price must be rendered
 * through `formatPrice` rather than calling `formatMoney` directly.
 */
export const CURRENCY_SYMBOL = "AUD";
export function formatPrice({ value, decimalPlaces = 2, symbol = CURRENCY_SYMBOL, symbolSeparation = false }) {
    return Utilities.formatMoney({
        value: value,
        decimalPlaces,
        symbol,
        symbolSeparation,
    });
}
